import loadGoogleMapsApi from 'load-google-maps-api';
import mapStyles from '../util/mapStyles';

export default {
    init() {
        // JavaScript to be fired on all pages
        const mapElement = document.querySelector("#partner-gmap");
        const mapData = JSON.parse(document.querySelector("#map-data").innerHTML);
        const key = mapElement ? mapElement.dataset.key : false;

        /**
         * Check that map element exists and then create
         * instance of Map if true
         */
            if (mapElement) {
                loadGoogleMapsApi({key: key}).then((googleMaps) => {
                    new Map(googleMaps, mapElement, mapData, mapStyles);
                });
            }

            class Map {
                constructor(googleMap, element, markerData, mapStyles) {
                    this.googleMap = googleMap;
                    this.element = element;
                    this.markerData = markerData;
                    this.mapStyles = mapStyles;
                    this.init = false;

                    this.addEventListeners();
                }

                /**
                 * Initializes map
                 */
                initMap() {
                    this.mapInstance = new this.googleMap.Map(mapElement, {
                        styles: this.mapStyles,
                        center: {
                            lat: 40.7484405,
                            lng: -73.9944191,
                        },
                        zoom: 12,
                    })

                    this.init = true;
                }

                /**
                 * Trigger resize event on google map instance
                 * forcing redraw in case of display issues
                 */
                reinitialize() {
                    this.googleMap.event.trigger(this.mapInstance, 'resize');
                }

                /**
                 * Add event listeners. I.e. when map tab is clicked
                 */
                addEventListeners() {
                    /**
                     * When map tab is open first initialize map + markers
                     * if tab is then opened again, just re initialize rather
                     * than re-render entire block
                     */
                    $("#airline-partner-tabs").on("shown.bs.tab", (e) => {
                        if (e.target.id == "map-tab") {
                            if (this.init) {
                                this.reinitialize();
                            } else {
                                this.initMap();
                                this.plotMarkers();
                            }
                        }
                    })
                }

                /**
                 * Plots markers this.markerData on google map instance
                 * applies event listener to show associated logos in JSON
                 */
                plotMarkers() {
                    let bounds = new this.googleMap.LatLngBounds();
                    let infoWindow = new this.googleMap.InfoWindow();

                    $.each(this.markerData, (i, airline) => {

                        // only add marker if location
                        // property exists on airline
                        if (airline.hasOwnProperty('location')) {
                            let marker = new this.googleMap.Marker({
                                position: {
                                    lat: parseFloat(airline.location.lat),
                                    lng: parseFloat(airline.location.lng),
                                },
                                icon: this.getMarkerIcon(),
                                map: this.mapInstance,
                                title: airline.title,
                            });

                            marker.addListener('click', () => {
                                infoWindow.setContent(
                                    '<div class="infowindow">' +
                                    '<div class="infowindow__logo-wrapper">' +
                                    '<img src="' + airline.logo + '" alt="' + airline.title + '" class="infowindow__logo">' +
                                    '</div>' +
                                    '</div>'
                                );
                                infoWindow.open(this.mapInstance, marker)
                            });

                            bounds.extend(marker.position);
                        }
                    })

                    // center around all markers
                    this.mapInstance.fitBounds(bounds);
                }

                /**
                 * Retrieves map marker from design
                 * and sets anchor point, fill color etc.
                 */
                getMarkerIcon() {
                    return {
                        path: "M 10.316406 29.394531 C 1.617188 17.050781 0 15.785156 0 11.25 C 0 5.035156 5.148438 0 11.5 0 C 17.851562 0 23 5.035156 23 11.25 C 23 15.785156 21.382812 17.050781 12.683594 29.394531 C 12.109375 30.203125 10.890625 30.203125 10.316406 29.394531 Z M 11.5 15.9375 C 14.144531 15.9375 16.292969 13.839844 16.292969 11.25 C 16.292969 8.660156 14.144531 6.5625 11.5 6.5625 C 8.855469 6.5625 6.707031 8.660156 6.707031 11.25 C 6.707031 13.839844 8.855469 15.9375 11.5 15.9375 Z M 11.5 15.9375",
                        fillColor: "#004BFF",
                        fillOpacity: 1,
                        strokeWeight: 0,
                        scale: 1,
                        anchor: new this.googleMap.Point(12, 30),
                    }
                }
            }
    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/airlinePartners.js